export default "/images/ireview-light.svg?40b6c18d8ae5fbb3650d80ebe691b492";